import type { GetUserRoleListResponse } from '@engagement-web-app/common';
import { APIError } from '../types';

export async function fetchUserRoles(): Promise<GetUserRoleListResponse> {
    try {
        const res = await fetch('/api/system/general-user-roles');
        const data = await res.json();
        if (!res.ok) throw APIError.fromResponse(data);
        return data;
    } catch (error) {
        if (error instanceof APIError) throw error;
        throw APIError.default();
    }
}
